import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMetricsColorTable = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "m42.342 18.901 9.328-7.264-19.18-7.945 1.459 11.732zm6.232 11.149 11.734 1.46-7.945-19.18-7.263 9.327zm.002 3.899-3.477 8.393 7.264 9.328 7.945-19.18zM42.343 45.1l-8.393 3.474-1.461 11.734 19.181-7.945zm-20.685-.001-9.328 7.264 19.18 7.945-1.46-11.732zM15.426 33.95 3.692 32.49l7.945 19.18 7.263-9.327zm3.475-12.291-7.264-9.329-7.945 19.18 11.732-1.459zm11.149-6.233 1.46-11.734-19.18 7.945 9.327 7.263z" }) }) })
});
export default SvgMetricsColorTable;
